var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import StatusLabel from '@/shared/components/StatusLabel';
import { formatListValue } from '@/shared/components/FormattedListValue';
var JobStatus = function (_a) {
    var status = _a.status, intl = _a.intl;
    var statuses = [];
    if (status === 0 /* Status.Initialized */ || status === 1 /* Status.Processing */) {
        statuses = ['info', 'active'];
    }
    if (status === 2 /* Status.Success */) {
        statuses = ['success'];
    }
    if (status === 3 /* Status.Failed */) {
        statuses = ['danger'];
    }
    if (status === 4 /* Status.Skipped */) {
        statuses = ['warning'];
    }
    return (_jsx(StatusLabel, __assign({ statuses: statuses, className: "document-status-label" }, { children: formatListValue({ id: status, list: 'jobstatus', intl: intl }) })));
};
export default JobStatus;
